import React from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import * as Styled from "./Style";

const BagSummary = (props) => {
  return (
    <Styled.BagSummaryStyle className={"bag-summary " + props.bagSummaryFixed}>
      <div className="summary-amounts">
        <div className="detail">
          Bag subtotal: {props.currency}
          {props.orderSubTotal}
        </div>
      </div>

      <div className="summary-proceed">
        {props.isAuRegion ? 
           <p>Delivery costs are calculated at checkout</p> 
           :  <p>Delivery cost and taxes are calculated at checkout</p>
        }
        <div>
          {
            Cookies.get("KK_IS_GUEST") == 1 ||
            (props.customerIsGuest == 1 && props.customerIsGuest) ||
            !props.isUserRegistered ? (
              // GUEST
              <div>
                <a
                  href={props.signinAndCheckoutLink}
                  onClick={props.signInCheckoutLinkClick}
                  className="link-as-btn ghost"
                >
                  {"Sign in & Checkout"}
                </a>
                {props.guestCheckoutLink ==
                "/checkout/#" + props.checkoutPagePath ? (
                  <Link
                    to={props.checkoutPagePath}
                    className="link-as-btn"
                  >
                    Checkout as Guest
                  </Link>
                ) : props.guestCheckoutLink == "" ? (
                  ""
                ) : props.guestCheckoutLink ? (
                  <a
                    href={props.guestCheckoutLink}
                    className="link-as-btn"
                  >
                    Checkout as Guest
                  </a>
                ) : (
                  ""
                )}
              </div>
            ) : (
              // SIGNED IN
              <a
                href={props.checkoutLink}
                className={
                  "link-as-btn " + (!props.checkoutLink ? "invalid" : "")
                }
              >
                Checkout
              </a>
            )
          }
        </div>
      </div>
    </Styled.BagSummaryStyle>
  );
};

export default BagSummary;
